module.exports = __webpack_public_path__ + "img/illustrator-api-catch.75be79ba.svg";